const state = {
  visited: {
    1: true,
    2: false,
    3: false
  },
  partnerAvaialable: false,
  serverAvailable: false,
  currentProjectName: ""
};

const getters = {
  stepStatus(state, getters) {
    return {
      1: getters.step1Status,
      2: getters.step2Status,
      3: getters.step3Status
    }
	},
  step1Status() {
    return true;
  },
  step2Status(state) {
    return state.partnerAvaialable;
  },
  step3Status(state) {
    return state.serverAvailable;
  },
  projectUrl() {
    switch(process.env.NODE_ENV) {
      case 'production':
        return 'https://learn.rumie.org/';
      case 'uat':
        return 'https://learn-uat.rumie.org/';
      default:
        return 'https://learn-staging.rumie.org/';
    }
  }
};

const actions = {
  partnerAvailableStatus({ commit}, data ) {
    let value = false;
    if(data.length > 0) {
      value = true;
      commit("PARTNER_IS_AVAILABLE", value);
    } else {
      commit("PARTNER_IS_AVAILABLE", value);
    }
  },
  serversAvailableStatus({ commit }, data) {
    let value = false;
    if(data.length > 0) {
      value = true;
      commit("SERVER_IS_AVAILABLE", value);
    } else {
      commit("SERVER_IS_AVAILABLE", value);
    }
  },
  setCurrentProjectName({ commit }, name) {
    commit("SET_PROJECT_NAME", name);
  },
};

const mutations = {
  PARTNER_IS_AVAILABLE(state, value) {
    state.partnerAvaialable = value;
  },
  SERVER_IS_AVAILABLE(state, value) {
    state.serverAvailable = value;
  },
  SET_PROJECT_NAME(state, value) {
    state.currentProjectName = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};